import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import { useMemo, useState, useEffect } from 'react';
import { useToken, createMedia } from '@rexlabs/styling';
export function useMediaQuery(queries) {
  var token = useToken();
  var mediaQuery = createMedia(queries, token);
  var mediaMatch = useMemo(function () {
    return window.matchMedia(mediaQuery);
  }, [mediaQuery]);

  var _useState = useState(mediaMatch.matches),
      _useState2 = _slicedToArray(_useState, 2),
      matches = _useState2[0],
      setMatches = _useState2[1];

  useEffect(function () {
    function listener(_ref) {
      var matches = _ref.matches;
      setMatches(matches);
    }

    mediaMatch.addEventListener('change', listener);
  }, [mediaMatch]);
  return matches;
}